import ComputerRoundedIcon from '@mui/icons-material/ComputerRounded';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from 'react-i18next';

import { useColorModeStore, type ColorModePreference } from '@/store/color-mode';

const ICONS: Record<ColorModePreference, typeof LightModeRoundedIcon> = {
  light: LightModeRoundedIcon,
  dark: DarkModeRoundedIcon,
  system: ComputerRoundedIcon,
};

/**
 * Steps dark → light → system. The accessible name describes what pressing it
 * will *do*, not what the icon currently shows, because "Dark" alone tells a
 * screen-reader user nothing about the outcome.
 */
export function ColorModeToggle() {
  const { t } = useTranslation();
  const preference = useColorModeStore((state) => state.preference);
  const cycle = useColorModeStore((state) => state.cycle);

  const Icon = ICONS[preference];
  const label = t(`colorMode.${preference}`);

  return (
    <Tooltip title={label}>
      <IconButton onClick={cycle} aria-label={label} size="small">
        <Icon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
